import React from 'react'

const ActionButton = ({
  onClick,
  icon,
  text,
  gradientColors = ['var(--theme-primary)', 'var(--theme-secondary)'],
  className = ""
}) => {
  const handleMouseEnter = (e) => {
    e.target.style.background = `linear-gradient(to right, var(--theme-gradient-start), var(--theme-gradient-end))`;
  };

  const handleMouseLeave = (e) => {
    e.target.style.background = `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1]})`;
  };

  return (
    <button
      onClick={onClick}
      className={`text-white font-semibold py-3 px-4 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex flex-col items-center gap-2 ${className}`}
      style={{
        background: `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1]})`,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {icon}
      <span className="text-sm">{text}</span>
    </button>
  );
};

export default ActionButton